import React, { useEffect } from 'react';
import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import * as actions from '../../reducers/form';
import * as api from '../../api/list'
import validateProps from '../../functions/validateProps'
import { enqueueSnackbar } from '../../reducers/notifier'
import SimpleAdd from '../../components/SimpleAdd'
import { Typography } from '@mui/material';
import { fetchDispath } from '../../functions/fetch'
import { set as autoSet } from '../../reducers/autocomplite';


export default function WorkEstimateFolderEdit({ history, match }) {
  const dispatch = useDispatch()
  const formName = 'WorkEstimateFolderEdit'
  useEffect(() => {
    dispatch(actions.formInitialize({ name: '', errorValidate: { name: false }, resource: undefined }, { name: formName }))
    return () => {
      dispatch(actions.formDestroy({ name: formName }))
    }
  }, [dispatch])
  useEffect(() => {
    dispatch(fetchDispath({
      progress: true,
      request: api.loadWorkEstimateById,
      param: {
        id: match.params.id
      }
    })).then(res => {
      dispatch(actions.formChangeAsObj({ name: res.get.name, resource: res.get.idParent }, { field: 'name', name: formName }))
      dispatch(autoSet({ value: res.get.idParent+"", label: res.get.parent }, { field: 'resource' }))

    }).catch(err => console.log(err))
  }, [dispatch, match.params.id])
  const form = useSelector(state => state.form[formName] || state.form.default)
  const { values } = form
  const arrProps = [
    { field: 'name', label: 'Наименование', type: 'text', validator: [value => value !== ''], errorText: 'Поле обязательно' },
    {
      field: 'resource', type: 'autoLoad', label: 'Папка',
      textProps: {
        path: api.loadWorkEstimate.path + '?folder=1',
        meta: {
          field: 'resource',
          value: 'id',
          labelFunc: (obj) => obj.name
        },
        selectProps: { isClearable: true },
      }
    },
  ]
  const handleSave = (e) => {
    e.preventDefault();
    const isError = validateProps(arrProps, values)
    dispatch(actions.formChange(isError.validate, { field: 'errorValidate', name: formName }))
    if (isError.check) {
      dispatch(enqueueSnackbar({
        message: `некорректные поля`,
        options: { variant: 'error' }
      }))
      return;
    }
    dispatch(actions.formSubmitAPI({
      props: { name: values.name, isFolder: true, parent: values.resource },
      url: api.updWorkEstimate.path({id: match.params.id}),
      method: api.updWorkEstimate.type,
      history: history
    }, formName))
  };
  return (
    <div className='App-paper'>
      <form autoComplete="off" onSubmit={handleSave}>
        <div style={{ padding: '16px' }}>
          <SimpleAdd
            arr={arrProps}
            formName={formName}
            title='Обновить папку'
          />
          <Typography>{values.parent}</Typography>
        </div>
        <Button color="primary" onClick={() => history.goBack()}>Назад </Button>
        <Button type="submit" color="primary">Сохранить</Button>
      </form>
    </div>
  );
}
